"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _Folders = require("FileManagerCore/selectors/Folders");

var _FolderTree = _interopRequireDefault(require("FileManagerCore/components/FolderTree"));

var _default = (0, _reactRedux.connect)(function (state, props) {
  return {
    tree: (0, _Folders.getFolderTree)(state),
    ancestors: (0, _Folders.getSelectedFolderAncestors)(state, props),
    folders: (0, _Folders.getFolders)(state)
  };
})(_FolderTree.default);

exports.default = _default;
module.exports = exports.default;